export default __webpack_public_path__ + "static/media/blood3.f7925695.jfif";